
import { StyleSizeType, StylePositionType } from '@/ui-kit/styles/enums';
import StyleClassNamesBuilder from '@/ui-kit/styles/helpers/StyleClassNamesBuilder';

export default {
  name: 'AuthNavLinks',
  props: {
    isBordered: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      StyleSizeType,
      StylePositionType,
    };
  },
  computed: {
    wrapperClassName() {
      return new StyleClassNamesBuilder('auth-nav')
        .addConditionClassName('bordered', this.isBordered)
        .build();
    },
  },
};
